/**
 * Scelta del suffisso singolare/plurale per i testi della selezione CV.
 *
 * Nel repo `t()` non pluralizza da sé: la chiave `_one`/`_other` si scegle al
 * call site (vedi `BulkActionBar`). Questi due helper tengono la regola in un
 * posto solo — la usano sia il modale del dettaglio che la barra flottante — e
 * sono testabili senza montare nulla. Chiavi statiche, nessun `t` qui dentro
 * (è un `.ts`).
 */

/**
 * Testi che contano i candidati scelti: uno → singolare, due o più → plurale.
 * A zero torna il plurale, che è la forma neutra: la barra non è montata a
 * selezione vuota, ma la chiave non deve mai risolversi a `undefined`.
 */
export const cvBarSuffix = (count: number): "one" | "other" =>
  count === 1 ? "one" : "other";

/**
 * Testo dei posti liberi: tre casi, non due. A slot pieni "nessun posto libero"
 * legge meglio di "0 posti liberi", e con un solo slot residuo serve il
 * singolare ("1 posto libero", non "1 posti liberi").
 */
export const cvSlotsLabelSuffix = (
  remaining: number,
): "full" | "one" | "other" => {
  if (remaining === 0) return "full";
  if (remaining === 1) return "one";
  return "other";
};
